import * as React from 'react';

import EmailEdit from './EmailEdit';
import EmailPreview from './EmailPreview';
import type { EmailContactFM } from './formModel';

interface EmailContact {
	id: number;
	email: string;
}

interface OwnProps {
	emailContact: EmailContact;
	editingId: Nullable<number>;
	selectEmailForEdit: (id: number) => void;
	deselectEmailForEdit: () => void;
	deleteEmailContact: (id: number) => Promise<void>;
	updateEmailContact: (id: number, form: EmailContactFM) => Promise<void>;
	formKey: string;
}

type Props = OwnProps;

const EmailItem: React.FC<Props> = (props) => {

	const {
		emailContact,
		editingId,
		selectEmailForEdit,
		deselectEmailForEdit,
		deleteEmailContact,
		updateEmailContact,
		formKey,
	} = props;

	const handleUpdateEmailContact = React.useCallback(async (form: EmailContactFM) => {
		await updateEmailContact(emailContact.id, form);
		deselectEmailForEdit();
	}, [deselectEmailForEdit, emailContact.id, updateEmailContact]);

	return emailContact.id === editingId ?
		(
			<EmailEdit
				form={formKey}
				initialValues={{
					email: emailContact.email,
				}}
				toggleEditInputOff={deselectEmailForEdit}
				updateEmailContact={handleUpdateEmailContact}
			/>) :
		(
			<EmailPreview
				deleteEmailContact={deleteEmailContact}
				emailContact={emailContact}
				selectEmailForEdit={selectEmailForEdit}
			/>
		);
};

export default React.memo(EmailItem);
